export let apiURL = 'https://myportal.setcpros.com/affiliate' //'http://localhost:3000'
export let customerPortalURL = 'https://portal.setcpros.com' //http://localhost:3001

export function setAPIUrl(hostname) {
    apiURL = `https://${hostname}/affiliate`
    customerPortalURL = `https://${hostname}`
}